export default __webpack_public_path__ + "static/media/la_bitbucket.d58553e5.svg";